<template>
  <div class="backgroundServicios" id="backgroud2">
    <div class="transbox" id="transbox2">
      <h1 class="pulse">Servicios</h1>
      <br>
      Nuestros servicios:
      <ul>
        <li>Gestor de residuos peligrosos.</li>
        <li>Gestor de residuos no peligrosos.</li>
        <li>Autorización gestión de amianto.</li>
        <li>Servicio de absorción y limpieza de fosas.</li>
        <li>Transportista autorizado de residuos. Flota de camiones de todo tipo y tonelaje.</li>
        <li>Valorización de materiales y subproductos.</li>
        <li>Minimización de materiales. Trituración de materiales.</li>
        <li>Lavado certificado de contenedores de 1000 litros.</li>
        <li>Desgasificación/inertización  de depósitos.</li>
        <li>Suministro de productos de seguridad industrial.</li>
        <li>Contenedores de gran volumen y autocompactadoras.</li>
        <li>Otros servicios</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Servicios',
  props: {
    msg: String
  },
  created(){
    window.addEventListener("scroll", function () {
      if (document.querySelector("#backgroud2").getBoundingClientRect().top < this.window.innerHeight){
        document.querySelector("#transbox2").classList.add("animation")
      } 
    })
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
li{
  margin: 0 40px 0;
}
a {
  color: #42b983;
}
div.backgroundServicios {
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 800px;
}

div.transbox {
   margin: 30px;
  padding : 5%;
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  background: linear-gradient(300deg, rgb(27, 94, 32, 0.8) 0%, rgba(144,238,144,0.8) 50%, rgb(255, 255, 255, 0.8) 100%);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  border-radius: 15px;
  min-width: 750px;
}

div {
  font-size: 30px;
}

.animation{
  animation-name: opacity1;
  animation-duration: 1000ms;
  transform-origin:70% 70%;
  animation-iteration-count: initial;
  animation-timing-function: linear;
}

@keyframes opacity1 {
  0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 0.8;
    }
}
.pulse:hover {
    animation-name: pulse_animation1;
    animation-duration: 5000ms;
    transform-origin:0% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes pulse_animation1 {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

</style>